"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _draftConvert = require("draft-convert");

var MSFT_LIST_CLASSNAMES = ['MsoListParagraphCxSpFirst', 'MsoListParagraphCxSpMiddle', 'MsoListParagraphCxSpLast'];
var MSFT_IGNORE = /mso-list:Ignore/;
/**
 * removes all children that are comments or intended to be ignored by programs
 * that don't know how to handle MS Word lists (we know how :))
 */

var extractListItemText = function extractListItemText(node) {
  var i = 0;

  while (i < node.childNodes.length) {
    if (node.childNodes[i].outerHTML && node.childNodes[i].outerHTML.match(MSFT_IGNORE) || node.childNodes[i].nodeName === '#comment') {
      node.removeChild(node.childNodes[i]);
      continue;
    }

    i++;
  }

  return node;
};

var getCleanDocument = function getCleanDocument(dirty) {
  // create a new target document to preserve input integrity
  var body = document.createElement('body');
  var nodes = dirty.childNodes; // need to keep track of whether or not we're in the middle of a list

  var listEl = null; // we can just linearly traverse the childNodes list because the list is a flattened DOM
  // representation, meaning element structure and order is maintained

  for (var i = 0; i < nodes.length; i++) {
    // if the element isn't an MS Word list element we don't need to do any post-processing
    // just clone it and move on
    if (MSFT_LIST_CLASSNAMES.indexOf(nodes[i].className) === -1) {
      body.appendChild(nodes[i].cloneNode(true));
      continue;
    } // otherwise, create a new list item element, extract the text from the list item,
    // and then append that list item to the global list element


    var newListItem = document.createElement('li');
    var textEl = extractListItemText(nodes[i].cloneNode(true));
    newListItem.appendChild(textEl);

    if (!listEl) {
      listEl = document.createElement('ul');
    }

    listEl.appendChild(newListItem);

    if (nodes[i].className === 'MsoListParagraphCxSpLast') {
      // if we're at the end of a list, append the list to the body and
      // then remove the reference for the next time through the loop
      body.appendChild(listEl);
      listEl = null;
    }
  }

  return body;
};

var _default = function _default(clipboardContent) {
  (0, _invariant.default)(typeof clipboardContent === 'string', "Expected 'clipboardContent' to be a string of HTML, received " + typeof clipboardContent);
  (0, _invariant.default)(clipboardContent.length > 0, 'Expected clipboardContent to have content, received empty string');
  return getCleanDocument((0, _draftConvert.parseHTML)(clipboardContent.replace(/(\r\n|\n|\r)/, ''))).outerHTML;
};

exports.default = _default;
module.exports = exports.default;